import React from 'react';
import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';

export type ComponentProps = {
  label: string;
};
export interface IconButtonProps extends MuiIconButtonProps {
  componentProps?: ComponentProps;
}

export const IconButton = ({
  componentProps,
  ...props
}: IconButtonProps): JSX.Element => {
  if (componentProps) {
    return (
      <div>
        <MuiIconButton {...props} />
        <span>{componentProps.label}</span>
      </div>
    );
  }
  return <MuiIconButton {...props} />;
};
